export default __webpack_public_path__ + "static/media/ADA.774e66b3.jpg";